import { render, staticRenderFns } from "./afDetectLinks.vue?vue&type=template&id=22288ef8&"
import script from "./afDetectLinks.vue?vue&type=script&lang=js&"
export * from "./afDetectLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22288ef8')) {
      api.createRecord('22288ef8', component.options)
    } else {
      api.reload('22288ef8', component.options)
    }
    module.hot.accept("./afDetectLinks.vue?vue&type=template&id=22288ef8&", function () {
      api.rerender('22288ef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/afDetectLinks.vue"
export default component.exports